var map = {
	"./addProduct.svg": 110,
	"./chart-icon.svg": 2418,
	"./complaint.svg": 9987,
	"./copy.svg": 1775,
	"./machine.svg": 8007,
	"./order.svg": 1360,
	"./payModule/after_sale.svg": 3145,
	"./payModule/home.svg": 7852,
	"./payModule/mine.svg": 5724,
	"./payModule/orderAll.svg": 1936,
	"./payModule/order_pending.svg": 2143,
	"./payModule/user.svg": 3828,
	"./productList.svg": 365,
	"./replenishment.svg": 4470,
	"./statistics.svg": 6305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1416;